module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "pg5"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "pg5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book has become a reality thanks to the assistance and support of many people. The constant encouragement and help from close friends and local historians has sustained me in this endeavor. I mention these in particular: Naomi Brewer, Carolyn Zogg, Philomena Cammuso, Bill Sebring, Allan Buddle, Jane Braunig and Gail Snyder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is my third book published by The History Press. Looking back now, I realize how much patience its extremely professional staff had as they guided me through the learning curves of completing my first book, "), _c('i', [_vm._v("The Seneca Army Depot: Fighting Wars from the New York Home Front")]), _vm._v(". Their expertise and my enhanced understanding of the process made publication of the second book, "), _c('i', [_vm._v("Seneca County and the Civil War")]), _vm._v(", much easier. Amanda Irle, Rick Delaney and the other staff have made my work on this third book pleasant and almost routine. I am grateful and thankful for that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Seneca County Board of Supervisors and several members of the county staff have been instrumental in making my work as the Seneca County historian possible and so enjoyable. Their support is greatly appreciated. They have given me much freedom to choose what topics I pursue for my writing and program presentations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The late Miss Ethel M. Buckley, my high school history teacher, instilled in me a great love of history. In much of my writing, I am guided by asking myself if Miss Buckley would think my wording is appropriate and would pass the test of being factually correct.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30444850","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgement.vue
// module id = 66
// module chunks = 0